import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	padding: 32px 32px 0 32px;
	height: 100%;
	overflow: hidden;
`;

export const MainWrapper = styled.div`
	display: flex;
	padding-top: 20px;
	height: 100%;
	overflow: hidden;
`;

export const Section = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	flex-direction: column;
	overflow: auto;

	&:first-child {
		min-width: 436px;
		width: 436px;
	}
`;

export const LoadingWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const Breadcrumbs = styled.div`
	display: flex;
	align-items: center;
	font-weight: 500;
	margin-top: 20px;
	margin-left: 10px;
	font-size: 16px;
	letter-spacing: 0.3px;
	color: ${colors.grey6};
	padding-bottom: 20px;

	span {
		cursor: pointer;

		&:last-child {
			cursor: default;
			color: ${colors.grey8};
		}
	}
`;

export const HorizontalGroup = styled.div`
	display: flex;
	align-items: center;
	min-height: 48px;
	padding-left: 8px;
	border-top: 1px solid ${colors.grey3};
	border-bottom: 1px dashed ${colors.grey3};

	> label {
		margin-right: 32px;
	}
`;

export const RadioLabel = styled.div`
	font-size: 16px;
	line-height: 24px;
	color: ${colors.grey8};
	padding-left: 3px;

	${({ disabled }) => disabled && `color: ${colors.grey5};`};
`;
